import Vue from 'vue'
import App from './App.vue'
import store from './store'
import '@icon-park/vue/styles/index.css'
import 'animate.css'
// JavaScript 文件 (如使用 Webpack 等构建工具)
import 'normalize.css'
import './assets/css/reset.css'
import router from './router'
const bus = new Vue()
Vue.prototype.$bus = bus
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
